import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

/**
 * Wrapper pour fournir le contexte Google OAuth à l'application
 */
const GoogleOAuthProviderWrapper = ({ children }) => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  if (!clientId) {
    console.warn('⚠️ REACT_APP_GOOGLE_CLIENT_ID non configuré');
    return children;
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      {children}
    </GoogleOAuthProvider>
  );
};

export default GoogleOAuthProviderWrapper;
